import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const PinIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 13 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M6.692 1.75A4.383 4.383 0 0 0 2.31 6.133c0 1.837 1.146 3.883 2.414 5.555a23.416 23.416 0 0 0 1.97 2.266l.26-.267a23.416 23.416 0 0 0 1.709-1.999c1.268-1.672 2.414-3.718 2.414-5.555A4.383 4.383 0 0 0 6.692 1.75Zm0 13.25-.504.555-.002-.002-.004-.003-.013-.012-.047-.044-.172-.164a24.896 24.896 0 0 1-2.422-2.735C2.23 10.884.81 8.496.81 6.133a5.883 5.883 0 0 1 11.767 0c0 2.363-1.421 4.75-2.72 6.462a24.896 24.896 0 0 1-2.593 2.899l-.047.044-.013.012-.004.003-.001.001s-.001.001-.506-.554Zm0 0 .506.554a.751.751 0 0 1-1.01 0L6.692 15Zm0-10.45a1.583 1.583 0 1 0 0 3.167 1.583 1.583 0 0 0 0-3.167ZM3.61 6.133a3.083 3.083 0 1 1 6.167 0 3.083 3.083 0 0 1-6.167 0Z"/>
    </svg>
);
PinIcon.displayName = 'PinIcon';
export default PinIcon;
